import { alpha, Box, Typography } from "@mui/material";
import { flownectColors, jobStatusColors } from "../../../../../const";

interface Props {
  icon: any;
  label: string;
  value: string | number | null | undefined;
  color?: string;
  status?: string;
  compact?: boolean;
}

export const InfoRow = ({ icon: Icon, label, value, color, status, compact = false }: Props) => {
  const colorSet = jobStatusColors[status || "scheduled"] || jobStatusColors.scheduled;

  return (
    <Box
      sx={{
        display: compact ? "grid" : "flex",
        gridTemplateColumns: compact ? "26px minmax(0, 1fr)" : undefined,
        gridTemplateRows: compact ? "auto auto" : undefined,
        columnGap: compact ? 0.75 : undefined,
        rowGap: compact ? 0.15 : undefined,
        gap: compact ? undefined : 1.5,
        alignItems: "flex-start",
        "@container (max-width: 520px)": {
          gap: compact ? undefined : 0.5,
          columnGap: compact ? 0.45 : undefined,
          gridTemplateColumns: compact ? "24px minmax(0, 1fr)" : undefined,
        },
      }}
    >
      <Box
        sx={{
          width: compact ? 26 : 36,
          height: compact ? 26 : 36,
          borderRadius: compact ? 1.5 : 2,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          bgcolor: alpha(color || colorSet.color, 0.1),
          flexShrink: 0,
          gridRow: compact ? "1 / span 2" : undefined,
          "@container (max-width: 520px)": {
            width: compact ? 24 : 24,
            height: compact ? 24 : 24,
          },
        }}
      >
        <Icon
          sx={{
            fontSize: compact ? 15 : 18,
            color: color || colorSet.color,
            "@container (max-width: 520px)": {
              fontSize: compact ? 14 : 13,
            },
          }}
        />
      </Box>

      <Box sx={{ flex: 1, minWidth: 0, display: compact ? "contents" : "block" }}>
        <Typography
          variant="caption"
          sx={{
            color: flownectColors.gray[600],
            fontWeight: 600,
            textTransform: "uppercase",
            letterSpacing: 0.5,
            fontSize: compact ? 10.5 : "0.65rem",
            lineHeight: compact ? 1.2 : undefined,
            gridColumn: compact ? 2 : undefined,
            "@container (max-width: 520px)": {
              fontSize: compact ? 10 : "0.48rem",
              lineHeight: compact ? 1.1 : 1.05,
              letterSpacing: 0.2,
            },
          }}
        >
          {label}
        </Typography>
        <Typography
          variant="body2"
          sx={{
            color: flownectColors.gray[800],
            fontWeight: 500,
            mt: compact ? 0 : 0.25,
            fontSize: compact ? 12.5 : undefined,
            lineHeight: compact ? 1.25 : undefined,
            wordBreak: "break-word",
            gridColumn: compact ? 2 : undefined,
            "@container (max-width: 520px)": {
              fontSize: compact ? 11 : "0.58rem",
              lineHeight: compact ? 1.16 : 1.12,
            },
          }}
        >
          {value || "—"}
        </Typography>
      </Box>
    </Box>
  );
};
